var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.375C17.0766 0.375 22 5.57812 22 12C22 18.4219 17.0766 23.625 11 23.625C4.92339 23.625 0 18.4219 0 12C0 5.57812 4.92339 0.375 11 0.375ZM11 4.875C8.84436 4.875 7.09678 6.72188 7.09678 9C7.09678 11.2781 8.84436 13.125 11 13.125C13.1556 13.125 14.9032 11.2781 14.9032 9C14.9032 6.72188 13.1556 4.875 11 4.875ZM11 21C13.6036 21 15.9367 19.7531 17.498 17.8031C16.6641 16.1437 15.0319 15 13.129 15C13.0226 15 12.9161 15.0188 12.8141 15.0516C12.2375 15.2484 11.6343 15.375 11 15.375C10.3657 15.375 9.75807 15.2484 9.18589 15.0516C9.08387 15.0188 8.97742 15 8.87097 15C6.96815 15 5.33589 16.1437 4.50202 17.8031C6.06331 19.7531 8.39637 21 11 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0e95e5ba2b7f1d0cc0b624b9d55f226a1881d8d39ad8aa8f80def9ebc6333e4c.svg";
export { ForwardRef as ReactComponent };